export enum ActionType {
    COACHING__BL__RELOAD = 'COACHING__BL__RELOAD',
    COACHING__BL__RELOAD_RESULT = 'COACHING__BL__RELOAD_RESULT',
    COACHING__BL__LIST_DOCUMENTS = 'COACHING__BL__LIST_DOCUMENTS',
    COACHING__BL__LIST_DOCUMENTS_RESULT = 'COACHING__BL__LIST_DOCUMENTS_RESULT',
}
